import React, { useMemo } from "react";
import { DatePicker, Segmented, Button } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DateRangeFilter = ({ value, onChange, onApply }) => {
  const presets = useMemo(
    () => [
      { label: "7d", value: [dayjs().subtract(6, "day"), dayjs()] },
      { label: "14d", value: [dayjs().subtract(13, "day"), dayjs()] },
      { label: "30d", value: [dayjs().subtract(29, "day"), dayjs()] },
      { label: "YTD", value: [dayjs().startOf("year"), dayjs()] },
    ],
    []
  );

  const disabledDate = (current) => current && current > dayjs().endOf("day");

  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
      <Segmented
        options={presets.map((p) => p.label)}
        onChange={(key) => {
          const found = presets.find((p) => p.label === key);
          if (found) onChange(found.value);
        }}
      />
      <RangePicker
        format="DD/MM/YYYY"
        allowClear={false}
        value={value}
        disabledDate={disabledDate}
        onChange={(dates) => {
          if (dates && dates[0] && dates[1]) onChange(dates);
        }}
        onCalendarChange={(dates) => {
          if (dates && dates[0] && !dates[1]) {
            // espera encerrar seleção; não faz nada
          }
        }}
        style={{ width: 260 }}
      />
      <Button
        type="primary"
        onClick={() => {
          if (value?.[0] && value?.[1]) onApply?.(value);
        }}
      >
        Aplicar
      </Button>
    </div>
  );
};

export default DateRangeFilter;
